/**
 * Runs `task` unless another task holding the same lock is still in flight.
 * Resolves true when the task ran, false when the call was dropped.
 *
 * The lock is a ref (not React state) so a second click in the same tick sees
 * it immediately, and it is held until the task SETTLES — a submit handler
 * that fires an async save and returns straight away would otherwise release
 * it while the request is still running.
 */
export const runExclusive = async (
  lock: { current: boolean },
  task: () => void | Promise<void>,
): Promise<boolean> => {
  if (lock.current) return false;
  lock.current = true;
  try {
    await task();
    return true;
  } finally {
    lock.current = false;
  }
};
